import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Film, Tv, Mic, Radio, Star, Heart } from 'lucide-react';

export const SIDE_ITEMS = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/movies', label: 'Movies', icon: Film },
  { to: '/shows', label: 'Shows', icon: Tv },
  { to: '/podcasts', label: 'Podcasts', icon: Mic },
  { to: '/live', label: 'Live', icon: Radio },
  { to: '/originals', label: 'Originals', icon: Star },
  { to: '/my-list', label: 'My List', icon: Heart },
];

export default function Sidebar() {
  return (
    <aside className="hidden xl:block w-[185px] flex-none sticky top-[70px] self-start z-10 h-[calc(100vh-70px)]" data-testid="sidebar">
      <nav className="pt-[36px] pr-[8px]">
        {SIDE_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `side-item ${isActive ? 'active' : ''}`} data-testid={`sidebar-${label.toLowerCase().replace(' ', '-')}`}>
            <Icon size={22} strokeWidth={1.7} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
